"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VeSumer__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "sumer",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "AcceptOwnership",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "appIncreaseAmountForsEnabled",
                type: "bool",
            },
        ],
        name: "AppIncreaseAmountForsToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "payer_addr",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "locktime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "int128",
                name: "_type",
                type: "int128",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "ts",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "proxy_address",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "HistoricalProxyToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "proxy_address",
                type: "address",
            },
        ],
        name: "LendingProxySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "NominateOwnership",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "staker_addr",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proxy_addr",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "add_amt",
                type: "uint256",
            },
        ],
        name: "ProxyAdd",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "proxyAddsEnabled",
                type: "bool",
            },
        ],
        name: "ProxyAddsToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "proxySlashesEnabled",
                type: "bool",
            },
        ],
        name: "ProxySlashesToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "appTransferFromsEnabled",
                type: "bool",
            },
        ],
        name: "ProxyTransferFromsToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "appTransferTosEnabled",
                type: "bool",
            },
        ],
        name: "ProxyTransferTosToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "smart_wallet_checker",
                type: "address",
            },
        ],
        name: "SmartWalletCheckerApplied",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "future_smart_wallet_checker",
                type: "address",
            },
        ],
        name: "SmartWalletCheckerComitted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "proxy_address",
                type: "address",
            },
        ],
        name: "StakerProxySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "prevSupply",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "supply",
                type: "uint256",
            },
        ],
        name: "Supply",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "app_addr",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "staker_addr",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "transfer_amt",
                type: "uint256",
            },
        ],
        name: "TransferFromApp",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "provider",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to_addr",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "ts",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "CHECKPOINT_ONLY",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CREATE_LOCK_TYPE",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEPOSIT_FOR_TYPE",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "INCREASE_LOCK_AMOUNT",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "INCREASE_UNLOCK_TIME",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXTIME",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXTIME_I128",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MULTIPLIER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PROXY_ADD",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PROXY_SLASH",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "TRANSFER_FROM_APP",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "USER_WITHDRAW",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "VOTE_WEIGHT_MULTIPLIER_I128",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "WEEK",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "appIncreaseAmountForsEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "appTransferFromsEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "appTransferTosEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "apply_smart_wallet_checker",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_t",
                type: "uint256",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_block",
                type: "uint256",
            },
        ],
        name: "balanceOfAt",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "checkpoint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker_addr",
                type: "address",
            },
        ],
        name: "checkpoint_user",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "commit_smart_wallet_checker",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_unlock_time",
                type: "uint256",
            },
        ],
        name: "create_lock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "curr_period_start",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "current_proxy",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "deposit_for",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "emergencyUnlockActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "epoch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "future_admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "future_smart_wallet_checker",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "get_last_point",
        outputs: [
            {
                components: [
                    {
                        internalType: "int128",
                        name: "bias",
                        type: "int128",
                    },
                    {
                        internalType: "int128",
                        name: "slope",
                        type: "int128",
                    },
                    {
                        internalType: "uint256",
                        name: "ts",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "blk",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "sumer_amt",
                        type: "uint256",
                    },
                ],
                internalType: "struct Point",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "get_last_user_bias",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "get_last_user_point",
        outputs: [
            {
                components: [
                    {
                        internalType: "int128",
                        name: "bias",
                        type: "int128",
                    },
                    {
                        internalType: "int128",
                        name: "slope",
                        type: "int128",
                    },
                    {
                        internalType: "uint256",
                        name: "ts",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "blk",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "sumer_amt",
                        type: "uint256",
                    },
                ],
                internalType: "struct Point",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "get_last_user_slope",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "historical_proxies",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "increase_amount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker_addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "increase_amount_for",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_unlock_time",
                type: "uint256",
            },
        ],
        name: "increase_unlock_time",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "locked",
        outputs: [
            {
                internalType: "int128",
                name: "amount",
                type: "int128",
            },
            {
                internalType: "uint256",
                name: "end",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
        ],
        name: "locked__amount",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
        ],
        name: "locked__end",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "next_period_start",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "point_history",
        outputs: [
            {
                internalType: "int128",
                name: "bias",
                type: "int128",
            },
            {
                internalType: "int128",
                name: "slope",
                type: "int128",
            },
            {
                internalType: "uint256",
                name: "ts",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "blk",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sumer_amt",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyAddsEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxySlashesEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker_addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_add_amt",
                type: "uint256",
            },
        ],
        name: "proxy_add",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker_addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_slash_amt",
                type: "uint256",
            },
        ],
        name: "proxy_slash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token_addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "recoverERC20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "slope_changes",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "smart_wallet_checker",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "staker_whitelisted_proxy",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "supply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "t",
                type: "uint256",
            },
        ],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_block",
                type: "uint256",
            },
        ],
        name: "totalSupplyAt",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staker_addr",
                type: "address",
            },
            {
                internalType: "address",
                name: "_app_addr",
                type: "address",
            },
            {
                internalType: "int128",
                name: "_transfer_amt",
                type: "int128",
            },
        ],
        name: "transfer_from_app",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "user_point_epoch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "user_point_history",
        outputs: [
            {
                internalType: "int128",
                name: "bias",
                type: "int128",
            },
            {
                internalType: "int128",
                name: "slope",
                type: "int128",
            },
            {
                internalType: "uint256",
                name: "ts",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "blk",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "sumer_amt",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_idx",
                type: "uint256",
            },
        ],
        name: "user_point_history__ts",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "user_proxy_balance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class VeSumer__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(sumer, overrides) {
        return super.getDeployTransaction(sumer, overrides || {});
    }
    deploy(sumer, overrides) {
        return super.deploy(sumer, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.VeSumer__factory = VeSumer__factory;
VeSumer__factory.bytecode = _bytecode;
VeSumer__factory.abi = _abi;
//# sourceMappingURL=VeSumer__factory.js.map